var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"the-header"},[_c('router-link',{staticClass:"the-header__logo",attrs:{"to":"/"}},[_c('img',{attrs:{"src":require("@/assets/nickjr.png")}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }